import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  listing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  posting: {
    init: 0,
    initErr: [],
    menu: {}
  },
  updateStatus: {
    init: 0,
    initErr: [],
    menu: {},
    statusList: []
  },
  claimEntry: {
    // Note that the levels are Claims -> Claim New -> Claim Detail
    init: 0,
    initErr: [],
    menu: {}
  },
  claimDetail: {
    init: 0,
    menu: {},
    saving: false,
    saveError: {
      fieldMessages: [],
      messages: []
    },
    // Claim Life Cycle state. Controls the steps within the Claim. Starts off as 1 but 0 is reserved for ClaimNew.
    claimLifeCycle: 0,
    promptWhenExit: true,
    commonInfo: {
      statusCode: undefined,
      statuses: [],
      intermediaryName: undefined,
      productDesc: undefined,
      busClsDesc: undefined,
      cover: undefined,
      coverTypeDesc: undefined,
      vehRegNo: undefined,
      engineNo: undefined,
      chassisNo: undefined,
      vehMake: undefined,
      vehMakeDesc: undefined,
      vehModel: undefined,
      vehModelDesc: undefined,
      travelType: undefined,
      tripType: undefined,
      travelArea: undefined,
      travelAreaDesc: undefined,
      schemeDesc: undefined,
      planDesc: undefined
    },
    commonForm: {
      clmRefNo: undefined,
      revision: undefined,
      appID: undefined,
      proposalNo: undefined,
      polNo: undefined,
      lossDate: undefined,
      ackDate: undefined,
      notDate: undefined,
      comDate: undefined,
      expDate: undefined,
      acceptDate: undefined,
      riskNo: undefined,
      itemNo: undefined,
      reqDate: undefined,
      recDate: undefined,
      lossPlace: undefined,
      cseLoss1: undefined,
      cseLoss2: undefined,
      cseLoss3: undefined,
      intermediary: undefined,
      product: undefined,
      busCls: undefined,
      scheme: undefined,
      planNo: undefined,
      appSalutation: undefined,
      appName: undefined
    },
    claimForm: {
      claimants: [],
      selectedClaimant: undefined,
      clmItems: [],
      selectedClmItem: undefined,
      clmReserves: []
    },
    claimParam: {
      nol1: {
        data: [],
        menu: {}
      },
      nol2: [],
      reserveInit: 0,
      reserve: []
    }
  }
}

export default {
  // deep clone here, we need the initialState for resetting of state in ClaimNew
  state: clone(initialState),
  getters,
  mutations,
  actions
}
